module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "well well-sm hoverwell thumbnail"
  }, [_c('div', {
    staticClass: "metric row"
  }, [_c('router-link', {
    staticClass: "measure",
    attrs: {
      "to": '/' + _vm.measure.link
    }
  }, [_c('i', {
    staticClass: "measure-icon fa fa-lg",
    class: _vm.measure.icon,
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.measure.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "filler"
  }), _vm._v(" "), _c('sparkline', {
    staticClass: "sparkline",
    attrs: {
      "id": _vm.measure.id,
      "history": _vm.measure.history
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-badge-outer"
  }, [_c('error-badge', {
    attrs: {
      "item": _vm.measure
    }
  })], 1)], 1), _vm._v(" "), (_vm.measure.narrative) ? _c('div', {
    staticClass: "narrative row"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "type": "animation"
    },
    on: {
      "enter": _vm.heightEnterAnimation,
      "leave": _vm.heightLeaveAnimation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpanded),
      expression: "isExpanded"
    }],
    staticClass: "narrative-text-container",
    attrs: {
      "id": _vm.narrativeId
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "narrative-text"
  }, [_vm._v(_vm._s(_vm.measure.narrative))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.measure.narrative) ? _c('a', {
    staticClass: "narrative-button",
    on: {
      "click": function($event) {
        _vm.isExpanded = !_vm.isExpanded
      }
    }
  }, [_c('i', {
    staticClass: "narrative-icon fa",
    class: {
      'fa-chevron-down': !_vm.isExpanded, 'fa-chevron-up': _vm.isExpanded
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720e9592","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/components/DashboardThumbnail.vue
// module id = 211
// module chunks = 5